export const HEADER_LABELS = [
  { key: 'ReqDate', label: 'Request Date', type: 'date' },
  { key: 'TravelerType_Description', label: 'Type of Traveler' },
  { key: 'TravelType_Description', label: 'Type of Travel' },
  { key: 'UserFullName', label: 'Employee Name' },
];

export const FLIGHT_COLUMNS = [
  'From City',
  'To Country',
  'To City',
  'Date',
  'Departure Time',
  'Pref. Airline',
  'Class',
];

export const HOTEL_COLUMNS = [
  'Country',
  'Place',
  'Check In Date',
  'Check Out Date',
  'Hotel Name',
];

export const CLIENT_COLUMNS = [
  'Client Name',
  'Company',
  'Contact No.',
  'Project Name',
];

export const FLIGHT_OPTION = [
  { key: 'Option1_Flight_QuoteValue', label: 'Quote Value' },
  { key: 'Option1_Flight_Refund', label: 'Refund' },
  { key: 'Option1_Flight_Rebooking', label: 'Rebooking' },
  { key: 'Option1_Flight_Terms', label: 'Date', type: 'Terms' },
  { key: 'TravelTime', label: 'Departure Time', type: 'time' },
  { key: 'Airline_Description', label: 'Preferred Airline' },
  { key: 'TravelClass', label: 'Class' },
];
